var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLostIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_8666_192082)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.08125 3.08125L11.9187 11.9187M11.9187 3.08125L3.08121 11.9187M13.75 7.5C13.75 10.9518 10.9518 13.75 7.5 13.75C4.04822 13.75 1.25 10.9518 1.25 7.5C1.25 4.04822 4.04822 1.25 7.5 1.25C10.9518 1.25 13.75 4.04822 13.75 7.5Z",
  stroke: "#F04438",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_8666_192082"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLostIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lostIcon.aa530470c2c363c4c6557e53035490d4.svg";